import styles from './index.module.scss';
import UserInfo from '../UserInfo';
import {Space} from 'antd';
import {Link} from 'react-router-dom';

export default function Header() {
    return (
        <div className={styles.root}>
            <Link to="/" className={styles.logo}>
                <img
                    className={styles.logoImg}
                    src={require('./img/logo.png')}
                    alt="logo"
                />

                <div className={styles.split} />

                <div className={styles.logoText}>校友 SAAS 后台管理</div>
            </Link>

            <Space split={<span className={styles.divider}>|</span>} size={40}>
                <UserInfo />
            </Space>
        </div>
    );
}
